import { Button, Popconfirm } from "antd";
import moment from "moment";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import { useMutation } from "react-query";
import OrderServices from "../../actions/order-actions/services";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";
import { restoreOption } from "../../actions/my-orders/services";

export default function TableRowCancelledDirectOrder({
  product,
  refetch,
}: any) {
  const { mutateAsync: deleteOpt, isLoading: deleteLoading } = useMutation(
    OrderServices.deleteOption,
    {
      onSuccess: () => {
        MyNotif("Option deleted successfully.", "success");
        refetch();
      },
    }
  );
  const { mutateAsync: restoreOpt, isLoading: restoreLoading } = useMutation(
    restoreOption,
    {
      onSuccess: () => {
        MyNotif(
          `Option restored successfully. You can check it in ${product.order_name} order`,
          "success"
        );
        refetch();
      },
    }
  );

  return (
    <tr key={product.id}>
      <td scope="row">
        <span className="myorder_order_name">{product.name}</span>
      </td>
      <td scope="row">
        <span>{product.article_name}</span>
      </td>
      <td scope="row">
        <span>{product.order_name}</span>
      </td>
      <td scope="row">
        <span>{moment(product.updated_at).format("DD/MM/YYYY")}</span>
      </td>
      <td>
        <div>
          <Popconfirm
            placement="top"
            title={"Are you sure you want to delete this order ?"}
            onConfirm={() => deleteOpt(product.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="ghost"
              size={"middle"}
              className="mr-2"
              style={{ borderRadius: "4px" }}
              icon={<DeleteOutlined style={{ color: "#00468c" }} />}
              loading={deleteLoading}
            >
              Delete
            </Button>
          </Popconfirm>
          <Popconfirm
            placement="top"
            title={"Are you sure you want to restore this order ?"}
            onConfirm={() => restoreOpt(product.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              size={"middle"}
              style={{ borderRadius: "4px" }}
              icon={
                <InboxOutlined
                  style={{ color: "#00468c", verticalAlign: "1px" }}
                />
              }
              loading={restoreLoading}
            >
              Restore
            </Button>
          </Popconfirm>
        </div>
      </td>
    </tr>
  );
}
